import { Paper } from '@mui/material';
import React, { useState, useEffect } from 'react';
import DataTableStyleEnum from '../../Enums/DataTableStyleEnum';
import CookieHelper from '../../Helpers/cookieHelper';
import DataTableHeader from './DataTableHeader';
import DataTableBody from './DataTableBody';
import ItemDetailBox from './ItemDetailBox';
import RoleService from '../../Services/roleService';

function getBlocks(type) {
  if (type == null) return null;
  const shownBlocks = {};
  if (type.BlocksInDataTable) {
    type.BlocksInDataTable.forEach((item) => {
      shownBlocks[item.name] = {
        value: CookieHelper.getCookie(type.uniquePageIdForBlockCookies + item.name, item.checkedDefault) === 'true',
        label: item.label,
        bgcolor: item.bgcolor,
      };
    });
  }
  return shownBlocks;
}

export default function DataTable(props) {
  const [selected, setSelected] = useState(props.selected);
  const [shownBlocks, setShownBlocks] = useState(() => getBlocks(props.type));

  // Mirrors the old componentWillReceiveProps: resync selected when the prop changes.
  useEffect(() => {
    setSelected(props.selected);
  }, [props.selected]);

  const colorDictionary = {};
  const complex = props.style !== DataTableStyleEnum.Simple;
  const nameOfTheIdField =
    props.type != null && props.type.NameOfTheIdField !== undefined ? props.type.NameOfTheIdField() : '';

  const clickOnCancel = () => {
    setSelected(-1);
    if (props.afterClickOnCancel) {
      props.afterClickOnCancel();
    }
  };

  const ClickOnDataFieldWithDetails = (idValue) => {
    setSelected((prev) => (idValue === prev ? -1 : idValue));
  };

  const renderTableRow = (listItem, lineIndex) => (
    <tbody key={`tbody${lineIndex}`}>
      <DataTableBody
        type={props.type}
        listItem={listItem}
        shownBlocks={shownBlocks}
        selected={selected}
        nameOfTheIdField={nameOfTheIdField}
        complex={complex}
        colorDictionary={colorDictionary}
        ClickOnDataFieldWithDetails={ClickOnDataFieldWithDetails}
        FieldsToShowInDataTable={props.FieldsToShowInDataTable}
        renderInputFieldFunction={props.renderInputFieldFunction}
        Lineindex={lineIndex}
        DataTableType={props.DataTableType}
        ModalFeature={props.ModalFeature}
        hiddenColumns={props.hiddenColumns}
      />
    </tbody>
  );

  const renderDetailBox = (listItem, key) => {
    if (props.rolekey && !RoleService.CheckUserPermission('detailBox', props.rolekey, 'visit')) return null;
    return (
      <ItemDetailBox
        key={key}
        selected={selected}
        item={listItem}
        type={props.type}
        getItemTypeFunction={props.getItemTypeFunction}
        clickOnCancel={clickOnCancel}
        popupEnabled={props.popupEnabled}
        nameOfTheIdField={nameOfTheIdField}
      />
    );
  };

  const renderBlockButtons = () => {
    if (!complex || shownBlocks === null) return undefined;
    const blockKeys = Object.keys(shownBlocks);
    if (blockKeys.length < 1) return null;
    return (
      <div className='d-flex '>
        {blockKeys.map((k) => (
          <div
            className='btn btn-light border btn-sm m-1'
            key={`block${k}`}
          >
            <input
              type='checkbox'
              id={`blockCheckBox${k}`}
              checked={shownBlocks[k].value}
              onChange={() => {
                const tempShownBlocks = { ...shownBlocks };
                tempShownBlocks[k].value = !tempShownBlocks[k].value;
                setShownBlocks(tempShownBlocks);
                CookieHelper.setCookie(props.type.uniquePageIdForBlockCookies + k, tempShownBlocks[k].value);
              }}
            />{' '}
            <label
              htmlFor={`blockCheckBox${k}`}
              className='m-1'
            >
              {` ${shownBlocks[k].label}`}
            </label>
          </div>
        ))}
      </div>
    );
  };

  const renderSmallDataTable = () => {
    if (props.thereIsNoSuchRowMessageCheck && props.itemList.length === 0) {
      return (
        <div className='bravo-ds'>
          <div className='empty-state'>
            <div className='ei'>
              <i className='fa-solid fa-table-list' />
            </div>
            <b>Nothing to show</b>
            <span>{props.thereIsNoSuchRowMessage}</span>
          </div>
        </div>
      );
    }
    return (
      <div className='bravo-ds FigmaDataTableBorder'>
        {renderBlockButtons()}
        <div className='table-wrap'>
          <table className='fixed_header stripped tab grid'>
            <DataTableHeader
              changeOrderBy={props.changeOrderBy}
              FieldsToShowInDataTable={props.FieldsToShowInDataTable}
              itemList={props.headeritemList}
              orderBy={props.orderBy}
              orderDirection={props.orderDirection}
              type={props.type}
              DataTableType={props.DataTableType}
              ModalFeature={props.ModalFeature}
              shownBlocks={shownBlocks}
              hiddenColumns={props.hiddenColumns}
            />
            {Array.isArray(props.itemList)
              ? props.itemList.map((item, Lineindex) => renderTableRow(item, Lineindex))
              : renderTableRow(props.itemList, '')}
          </table>
        </div>
        {Array.isArray(props.itemList) ? props.itemList.map(renderDetailBox) : ''}
      </div>
    );
  };

  if (props.smallDataTable) {
    return renderSmallDataTable();
  }

  if (props.itemList && props.thereIsNoSuchRowMessageCheck) {
    if (props.itemList.length === 0) {
      return (
        <div className='bravo-ds'>
          <div className='empty-state'>
            <div className='ei'>
              <i className='fa-solid fa-table-list' />
            </div>
            <b>Nothing to show</b>
            <span>{props.thereIsNoSuchRowMessage}</span>
          </div>
        </div>
      );
    }
    return (
      <div className='bravo-ds FigmaDataTableBorder'>
        <Paper elevation={0}>
          {renderBlockButtons()}
          <div className='table-wrap'>
            <table className='fixed_header stripped tab grid'>
              <DataTableHeader
                changeOrderBy={props.changeOrderBy}
                FieldsToShowInDataTable={props.FieldsToShowInDataTable}
                itemList={props.headeritemList}
                orderBy={props.orderBy}
                orderDirection={props.orderDirection}
                type={props.type}
                DataTableType={props.DataTableType}
                ModalFeature={props.ModalFeature}
                shownBlocks={shownBlocks}
                hiddenColumns={props.hiddenColumns}
              />
              {Array.isArray(props.itemList)
                ? props.itemList.map((item, Lineindex) => renderTableRow(item, Lineindex))
                : renderTableRow(props.itemList, '')}
            </table>
          </div>
          {props.itemList.map((item, key) => renderDetailBox(item, key))}
        </Paper>
      </div>
    );
  }

  return 'Error! ErrorCode: DTF208';
}

DataTable.defaultProps = {
  itemList: [],
  selectable: true,
  style: DataTableStyleEnum.ComplexWithoutTranslation,
  thereIsNoSuchRowMessage: 'There is no such row.',
  popupEnabled: false,
  thereIsNoSuchRowMessageCheck: true,
  rolekey: '',
  smallDataTable: false,
  afterClickOnCancel: () => {},
};
